module.exports = __webpack_public_path__ + "static/media/recruitment.91940985.webp";